import { lighten, makeStyles } from '@material-ui/core/styles';
import { green, amber, red } from '@material-ui/core/colors';
// Palete de colors aqui: https://material-ui.com/customization/palette/

import { complementaryColor, mainColor } from '../utils/constants';

export const customCheck = makeStyles(() => ({
  root: {
    color: complementaryColor,
    '&$checked': {
      color: complementaryColor,
    },
  },
  checked: {},
}));

export const customOptionsTableStyles = makeStyles((theme) => ({
  tableRowHeaderBgColor: {
    backgroundColor: '#e3e3e3',
  },
  tableRowBgColor1: {
    backgroundColor: '#f5f5f5',
  },
  tableRowBgColor2: {
    backgroundColor: 'white',
  },
  tableRowMarked: {
    backgroundColor: '#bfe6e6',
  },
  tableRowActive: {
    backgroundColor: '#bae2b1',
  },
  tableRowPending: {
    backgroundColor: '#eefaac',
  },
  text: {
    padding: theme.spacing(1, 2),
  },
  avatarAmber: {
    color: '#fff',
    backgroundColor: amber[500],
  },
  avatarGreen: {
    color: '#fff',
    backgroundColor: green[500],
  },
  avatarRed: {
    color: '#fff',
    backgroundColor: red[500],
  },
  avatarAmberSquare: {
    color: '#fff',
    backgroundColor: amber[500],
    height: 30,
  },
  avatarGreenSquare: {
    color: '#fff',
    backgroundColor: green[500],
    height: 30,
  },
  avatarRedSquare: {
    color: '#fff',
    backgroundColor: red[500],
    height: 30,
  }
}));

export const deleteToolBar = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(5),
  },
  highlight:
   theme.palette.type === 'light'
     ? {
       color: theme.palette.secondary.main,
       backgroundColor: lighten(theme.palette.secondary.light, 0.85),
     } : {
       color: theme.palette.text.primary,
       backgroundColor: theme.palette.secondary.dark,
     },
  title: {
    flex: '1 1 100%',
  },
}));

export const loginForm = makeStyles((theme) => ({
  root: {
    // backgroundColor: 'yellow',
  },
  containerImg:{
    padding: theme.spacing(1)
  },
  containerLogoItem:{
    borderStyle: 'solid',
    borderWidth: 'thin',
    color: complementaryColor,
    padding: theme.spacing(1),
    margin: theme.spacing(0,2),
    height: 185,
  },
  content: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // backgroundColor: 'red',
  },
  divider: {
    margin: theme.spacing(2, 0),
    backgroundColor: theme.palette.secondary.dark,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: complementaryColor,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  loginButton: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: complementaryColor,
    color: '#FFF',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: mainColor,
      color: '#FFF',
    },
  },
  typography1: {
    marginBottom: theme.spacing(0),
  },
  typography2: {
    marginBottom: theme.spacing(5),
  },
}));

export const noMatch = makeStyles((theme) => ({
  content: {
    marginTop: theme.spacing(26),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
  },
}));

export const paginationTable = makeStyles(() => ({
  root: {
    flexShrink: 0,
  },
}));

export const resetPasswordForm = makeStyles((theme) => ({
  content: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // backgroundColor: 'red',
  },
}));

export const searchField = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
  },
}));

export const sectionTitle = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    color: complementaryColor,
    fontWeight: 'bold',
  },
}));

export const tableTitle = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(2),
    fontWeight: 'bold',
  },
  titleWithOutMargin: {
    fontWeight: 'bold',
  },
}));

export const tableContainer = makeStyles((theme) => ({
  container385px: {
    maxHeight: 375,
  },  
}));

export const varStyles = makeStyles((theme) => ({
  title: {
    color: complementaryColor,
    fontWeight: 'bold',
  },
  subTitle: {
    color: complementaryColor,
  },
  footer: {
    // color: 'red',
    marginTop: theme.spacing(1),
  },
}));
